import CustomDatePicker from '~/js/components/form-controls/CustomDatePicker';
import CountryStateSelector from '~/js/components/form-controls/CountryStateSelector';
import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';
// import CreditCard from '~/js/components/CreditCard';
import PropTypes from 'prop-types';

const { Component } = React;

class BrochureForm extends Component {
  static propTypes = {
    countries: PropTypes.array,
    ccCountries: PropTypes.array,
    states: PropTypes.array,
    ccStates: PropTypes.array
  };

  static defaultProps = {
    countries: [],
    ccCountries: [],
    states: [],
    ccStates: []
  };

  constructor(props) {
    super(props);

    this.state = {
      toggleVersion: false,
      toggleCardDetails: false,
      toggleBillingDetails: true,
      toggleWeddingDate: false,
      brochureType: 'printed',
      csrfToken: beaches_app.page.csrfToken,
    };
  }

  componentDidMount() {
    if (this.state.brochureType === 'printed') {
      this._phoneNumberValidations();
    }
  }
  componentDidUpdate() {
    if (this.state.brochureType === 'printed') {
      this._phoneNumberValidations();
    }
  }

  _phoneNumberValidations = () => {
    const $landlineNumber = $('#landLineNumber');
    const $mobileNumber = $('#mobileNumber');

    $landlineNumber.on('change', function validateNumber() {
      if (this.value) {
        $mobileNumber.removeAttr('required');
        $mobileNumber.trigger( 'blur' );
      }else {
        $mobileNumber.attr('required', true);
      }
    });

    $mobileNumber.on('change', function validateNumber() {
      if (this.value) {
        $landlineNumber.removeAttr('required');
        $landlineNumber.trigger( 'blur' );
      }else {
        $landlineNumber.attr('required', true);
      }
    });

    if ($landlineNumber.val()) {
      $mobileNumber.removeAttr('required');
      $mobileNumber.trigger( 'blur' );
    }

    if ($mobileNumber.val()) {
      $landlineNumber.removeAttr('required');
      $landlineNumber.trigger( 'blur' );
    }
  }

  toggleCardDetails = (event) => {
    if (event.target.classList[0] === 'brochure-confirmation-yes') {
      this.setState({ toggleCardDetails: true });
    } else if (event.target.classList[0] === 'brochure-confirmation-no') {
      this.setState({ toggleCardDetails: false, toggleBillingDetails: true });
    }
  }

  toggleBillingDetails = (event) => {
    if (event.target.checked === false ) {
      this.setState({ toggleBillingDetails: true });
    } else if (event.target.checked ) {
      this.setState({ toggleBillingDetails: false });
    }
  }

  toggleWeddingDate = (event) => {
    if (event.target.id === 'sandalsWeddingYes') {
      this.setState({ toggleWeddingDate: true });
    } else {
      this.setState({ toggleWeddingDate: false });
    }
  }

  render() {
    const { toggleVersion, toggleWeddingDate, brochureType, csrfToken } = this.state;
    const validateGcv = toggleVersion ? '{"email": true}' : '{"email":true, "landline": true, "mobile": true, "address": true}';

    return (
      <form className="request-brochure-form xs-12 lg-12" id="request-brochure-form" action="/brochure/submit/" data-location={`/brochure/thankyou/?brochureType=${brochureType}`} data-validate-gcv={validateGcv}>
        <input type="hidden" name="csrfToken" value={csrfToken} />
        <input type="hidden" name="brochureType" value="printed" />
        <div className="container form-top-container">
          <fieldset className="form-controls-wrapper">
            <div className="row">
              <label className="form-label xs-12 lg-5" htmlFor="brochureVersion">
                Which brochure would you like?<span>*</span>
              </label>
              <div className="control-wrapper custom-ddl pr xs-12 lg-7">
                <select name="brochureVersion" id="brochureVersion" required>
                  <option value="">Select One</option>
                  {/* <option value="Beaches">Beaches Resorts</option>
                  <option value="Sandals">Sandals Resorts</option>
                  <option value="Sandals & Beaches">Sandals and Beaches</option>
                  <option value="Sandals Honeymoon">Sandals Honeymoon</option>
                  <option value="SANDALS WEDDING">Sandals Wedding</option> */}
                  <option value="Weddings Aisle to Isle">Weddings-Aisle to Isle</option>
                </select>
              </div>

              <p className="brochure-instructions xs-12">We mail Beaches Brochures to US and Canada only. Please <a className="blue-link" href="https://www.beaches.co.uk/brochure/">click here</a> for European Beaches Brochure requests.</p>

              <label className="form-label xs-12 lg-5"htmlFor="title">
                Title<span>*</span>
              </label>
              <div className="control-wrapper custom-ddl pr xs-12 lg-7">
                <select name="title" id="title" required>
                  <option value="">Select a Title</option>
                  <option value="dr">Dr.</option>
                  <option value="mr">Mr.</option>
                  <option value="mrs">Mrs.</option>
                  <option value="miss">Miss</option>
                </select>
              </div>

              <label className="form-label xs-12 lg-5" htmlFor="firstName">
                  First Name<span>*</span>
              </label>
              <div className="control-wrapper xs-12 lg-7">
                <input
                  type="text"
                  name="firstName"
                  id="firstName"
                  maxLength="50"
                  required />
              </div>

              <label className="form-label xs-12 lg-5" htmlFor="lastName">
                Last Name<span>*</span>
              </label>
              <div className="control-wrapper xs-12 lg-7">
                <input
                  type="text"
                  name="lastName"
                  id="lastName"
                  maxLength="50"
                  required />
              </div>

              { !toggleVersion &&
                <div className="printed-section xs-12">
                  <div className="row">
                    <label className="form-label xs-12 lg-5" htmlFor="address">
                      Address<span>*</span>
                    </label>
                    <div className="control-wrapper xs-12 lg-7">
                      <input
                        type="text"
                        name="address"
                        id="address"
                        className="gcvAddressField1"
                        maxLength="500"
                        required />
                    </div>
                    <label className="form-label xs-12 lg-5" htmlFor="suite">
                      Apt/Suite
                    </label>
                    <div className="control-wrapper xs-12 lg-7">
                      <input
                        type="text"
                        name="suite"
                        maxLength="50"
                        id="suite" />
                    </div>
                  </div>
                </div>
              }

              <div className="xs-12">
                <CountryStateSelector
                  countries={ this.props.countries }
                  states={ this.props.states }
                  countryName="country"
                  stateName="state"
                  stateLabelWrapper="xs-12 lg-5"
                  stateInputWrapper="xs-12 lg-7"
                  countryLabelWrapper="xs-12 lg-5"
                  countryInputWrapper="xs-12 lg-7"
                />
              </div>


              { !toggleVersion &&
                <div className="printed-section xs-12">
                  <div className="row">
                    <label className="form-label xs-12 lg-5" htmlFor="city">
                      City<span>*</span>
                    </label>
                    <div className="control-wrapper xs-12 lg-7">
                      <input
                        type="text"
                        name="city"
                        id="city"
                        className="gcvCityField"
                        maxLength="200"
                        required />
                    </div>


                    <label className="form-label xs-12 lg-5" htmlFor="zipCode">
                        Zip Code<span>*</span>
                    </label>
                    <div className="control-wrapper xs-12 lg-7">
                      <input
                        type="text"
                        name="zipCode"
                        id="zipCode"
                        className="gcvZipField"
                        maxLength="100"
                        required />
                    </div>
                  </div>
                </div>
              }

              <label className="form-label xs-12 lg-5" htmlFor="email">
                Email<span>*</span>
              </label>
              <div className="control-wrapper xs-12 lg-7">
                <input
                  type="email"
                  name="email"
                  id="email"
                  maxLength="100"
                  className="gcvEmailField"
                  maxLength="70"
                  required />
              </div>

              { !toggleVersion &&
                <div className="printed-section xs-12">
                  <div className="row">
                    <label className="form-label cel-instructions xs-12">
                        Please provide us with your phone number<span>*</span>
                    </label>

                    {/* <label id="phone-number" className="form-label xs-12 lg-5" htmlFor="landLineNumber">
                        Landline Number
                    </label>
                    <div className="control-wrapper xs-12 lg-7 row">
                      <span className="countryCode xs-4 lg-2 txt-center">+1</span>
                      <input
                        type="phone"
                        name="landLineNumber"
                        id="landLineNumber"
                        className="xs-8 lg-10 gcvLandlineField"
                        minLength="8"
                        maxLength="50"
                        required />
                    </div> */}

                    <label id="phone-number" className="form-label xs-12 lg-5" htmlFor="phoneNumber">
                      Phone Number
                    </label>
                    <div className="control-wrapper xs-12 lg-7 row">
                      <span className="countryCode xs-4 lg-2 txt-center">+1</span>
                      <input
                        type="phone"
                        name="phoneNumber"
                        id="phoneNumber"
                        className="xs-8 lg-10 phone-number"
                        minLength="8"
                        maxLength="50"
                        required />
                    </div>

                    <div class="row ck-section sms hideSms">
                      <div class="xs-2 lg-1 checkbox-btn-wrapper pr">
                        <input type="checkbox" id="subscribeSms" name="subscribeSms" value="true"/>
                        <label for="subscribeSms" class="checkbox-btn" required></label>
                      </div>
                      <label for="subscribeSms" class="xs-10 xxl-11 ck-label checkbox-text ck-2">
                        By submitting this form, you agree to receive personalized text notifications and offers from Beaches delivered to the phone number provided at opt-in. Message and data rates may apply. Message frequency varies. You can unsubscribe at any time by replying <strong>STOP</strong>. For Customer Support reply <strong>HELP</strong> or contact us at 1-800-SANDALS. <b><a class='blue-link' href="/general/terms/">Terms & Conditions</a></b> & <b><a class='blue-link' href="/general/privacy/">Privacy Policy</a></b>.
                      </label>
                    </div>

                    <label htmlFor="preferredCallBackTime" className="form-label xs-12 lg-5 radio-label">
                        Would you like for us to call you?<span>*</span>
                    </label>
                    <div className="xs-12 lg-7">
                      <div className="radio-row row">
                        <div className="radio-btn-wrapper control-wrapper xs-2 lg-2 pr">
                          <input type="radio" name="preferredCallBackTime" value="true" id="callYes" />
                          <label htmlFor="callYes" className="radio-btn"/>
                        </div>
                        <label htmlFor="callYes" className="xs-4 lg-4">Yes</label>
                        <div className="radio-btn-wrapper control-wrapper xs-2 lg-2 pr">
                          <input type="radio" name="preferredCallBackTime" value="false" id="callNo" defaultChecked />
                          <label htmlFor="callNo" className="radio-btn"/>
                        </div>
                        <label htmlFor="callNo" className="xs-4 lg-4">No</label>
                      </div>
                    </div>

                  </div>
                </div>
              }

              <label htmlFor="sandalsWedding" className="form-label xs-12 lg-5 radio-label">
                  Are you interested in a Beaches Wedding?
              </label>
              <div className="xs-12 lg-7">
                <div className="radio-row row">
                  <div className="radio-btn-wrapper control-wrapper xs-2 lg-2 pr">
                    <input type="radio" name="sandalsWedding" value="true" id="sandalsWeddingYes" onChange={this.toggleWeddingDate} />
                    <label htmlFor="sandalsWeddingYes" className="radio-btn"/>
                  </div>
                  <label htmlFor="sandalsWeddingYes" onChange={this.toggleWeddingDate} className="xs-4 lg-4">Yes</label>
                  <div className="radio-btn-wrapper control-wrapper xs-2 lg-2 pr">
                    <input type="radio" name="sandalsWedding" value="false" id="sandalsWeddingNo" defaultChecked onChange={this.toggleWeddingDate} />
                    <label htmlFor="sandalsWeddingNo" className="radio-btn"/>
                  </div>
                  <label htmlFor="sandalsWeddingNo" onChange={this.toggleWeddingDate}  className="xs-4 lg-4">No</label>
                </div>
              </div>

              { toggleWeddingDate &&
                <div className="wedding-date-row xs-12">
                  <div className="row">
                    <label htmlFor="weddingDate" className="form-label xs-12 lg-5">
                        Wedding Date:
                    </label>
                    <CustomDatePicker
                      name="weddingDate"
                      wrapperClassName="xs-12 lg-7"
                      inputClassName="wedding-date-input"
                      isRequired
                      displayStringDate={false}
                      displayPlaceHolder
                    />
                  </div>
                </div>
              }

              <label htmlFor="sandalsHoneymoon" className="form-label xs-12 lg-5 radio-label">
                  Are you interested in a Beaches Honeymoon?
              </label>
              <div className="xs-12 lg-7">
                <div className="radio-row row">
                  <div className="radio-btn-wrapper control-wrapper xs-2 lg-2 pr">
                    <input type="radio" name="sandalsHoneymoon" value="true" id="sandalsHoneymoonYes" />
                    <label htmlFor="sandalsHoneymoonYes" className="radio-btn"/>
                  </div>
                  <label htmlFor="sandalsHoneymoonYes" className="xs-4 lg-4">Yes</label>
                  <div className="radio-btn-wrapper control-wrapper xs-2 lg-2 pr">
                    <input type="radio" name="sandalsHoneymoon" value="false" id="sandalsHoneymoonNo" defaultChecked />
                    <label htmlFor="sandalsHoneymoonNo" className="radio-btn"/>
                  </div>
                  <label htmlFor="sandalsHoneymoonNo" className="xs-4 lg-4">No</label>
                </div>
              </div>


              <p className="disclaimer-text xs-12"><sup className="blue-link">*</sup>Denotes required fields</p>
            </div>
          </fieldset>
        </div>

        <div className="container">
          <fieldset className="form-footer">
            <div className="row">
              <div className="xs-2 sm-1 lg-1 checkbox-btn-wrapper pr">
                <input type="checkbox" id="acceptTerms" name="acceptTerms" value="true"/>
                <label htmlFor="acceptTerms" className="checkbox-btn"/>
              </div>

              <label htmlFor="acceptTerms" className="form-label xs-10 sm-11 lg-11 checkbox-text js-terms-label">I have read and agree to the <a href="/general/terms/" className="blue-link">terms and conditions</a>.</label>

              <div className="xs-2 sm-1 lg-1 checkbox-btn-wrapper pr">
                <input type="checkbox" id="subscribeEmail" name="subscribeEmail" value="true" />
                <label htmlFor="subscribeEmail" className="checkbox-btn"/>
              </div>

              <label htmlFor="subscribeEmail" className="form-label xs-10 sm-11 lg-11 checkbox-text">
                I want to receive promotional emails about Beaches Resorts from Unique Travel Corp.,
                the Worldwide Representative of Beaches Resorts, c/o P.O. Box SS-19020, Nassau, Bahamas.
                You can contact us at <a className="blue-link" href="mailto:info@beaches.com">info@beaches.com</a>. You may unsubscribe at any time.
              </label>

              <div className="xs-12 recaptcha-row">
                <CustomRecaptcha
                  wrapperClassName="xs-12 lg-12"
                />
              </div>

              <div className="xs-12">
                <button className="form-submit-button">
                  SUBMIT <i className="icon-play-beach" />
                </button>
              </div>
            </div>
          </fieldset>
        </div>
      </form>
    );
  }
}

export default BrochureForm;
